<script>
  const server_config = {
    url:'https://fota.unione-rugged.cn/uploadServer'
    // url:'http://192.168.108.139:8888/uploadServer'
  };
  export default {
    server_config
  }
</script>

